<app-slices [slices]="slices"></app-slices>
